import React from 'react'
import styled from '@emotion/styled'
import { spacing } from '@mobi/component-library/Theme/Common'
import type { FollowMeProfile } from '@core/Areas/FollowMe/types'
import { FollowButton } from '@core/Areas/FollowMe/Components/Common/FollowButton'
import { EditMyProfile } from '@core/Areas/FollowMe/Components/EditMyProfile'

export const PrimaryActionSection: React.FC<{ profile: FollowMeProfile; isMyProfile: boolean }> = ({
  profile,
  isMyProfile,
}) => {
  return (
    <WrapperStyled>
      {isMyProfile ? (
        <EditMyProfile />
      ) : (
        <FollowButton
          accountId={profile.id}
          accountDisplayName={profile.displayName}
          isFollowing={profile.isFollowing}
          isNotificationsEnabled={profile.isNotificationsEnabled}
          location='profile'
        />
      )}
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  alignSelf: 'stretch',
  display: 'flex',
  gap: spacing.smx1,

  '> button:first-of-type': { flex: 1 },
})
